import { render, staticRenderFns } from "./classScheduleCard.vue?vue&type=template&id=6479cdd8&scoped=true"
import script from "./classScheduleCard.vue?vue&type=script&lang=js"
export * from "./classScheduleCard.vue?vue&type=script&lang=js"
import style0 from "./classScheduleCard.vue?vue&type=style&index=0&id=6479cdd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479cdd8",
  null
  
)

export default component.exports